import React from 'react';
import '../Estilos/Estilo.scss';
import { Paginacion, getCurrentPage } from '../util/paginacion';
import Spinner from "react-bootstrap/Spinner";



class OFFERS extends React.Component {
    constructor(props) {
        super(props);
        var fecha = new Date(Date.now());

        this.state = {
            id: props.id,
            offers: props.offers,
            currentPageoffers: 1,
            loadingoffers: true,
            offersActuales: [],
            offersFintrade: [],
            itemPerPage: props.item,
            vacia: false

        };
        if (this.state.offers.length === 0) {
            this.state.vacia = true;
        }

        else {

            this.state.offers.map(({ title, limitDate, link, description, publicationDate }) => {
                if (new Date(limitDate.concat('T23:59:59')) >= fecha) {
                    this.state.offersFintrade = this.state.offersFintrade.concat({ title, limitDate, link, description, publicationDate });
                }
            });
        }

    }
    render() {
        const windowWidth = window.innerWidth;
        const isDesktop = windowWidth > 600;
        return (
            <div>
                <div>
                    {this.state.vacia ? <h1>There are no current offers</h1> : ''}
                    {this.setState({ offersActuales: this.state.offersFintrade.slice((this.state.currentPageoffers - 1) * this.state.itemPerPage, this.state.currentPageoffers * this.state.itemPerPage), loadingoffers: false })}

                    <div class='com-structure'>
                        {this.state.loadingoffers & !this.state.vacia ? <Spinner /> :
                            this.state.offersActuales.map((
                                { title, limitDate, link, description, publicationDate }) => {
                                return (
                                    <div class='offers-card' on >

                                        <table>
                                            <tr>
                                                <td>
                                                    <h1><a href={link}><b>{title}</b></a></h1>
                                                </td>
                                                {isDesktop ?
                                                    <td>
                                                        <a href={link}><img src='assets/img/logos/GRyS-logo.png' height="80px" width="180px" alt='Imagen del proyecto' /></a>
                                                    </td> : null}
                                            </tr>
                                            <tr><h4><b>Deadline: </b>{limitDate}</h4></tr>
                                            <tr>

                                                <div class="description">
                                                    <p>{description}</p>

                                                </div>

                                            </tr>
                                            <tr>
                                                <div class="pie-card">
                                                    <p><b>Published: </b>{publicationDate}</p>
                                                </div>
                                            </tr>
                                        </table>


                                    </div>
                                );

                            })}
                    </div>
                </div>

                <Paginacion id={this.state.id} itemPerPage={this.state.itemPerPage} length={this.state.offers.length} />
                {this.setState({ currentPageoffers: getCurrentPage(this.state.id) })}
            </div>
        );

    }


}


export default OFFERS;